import ApplicationController from '../application_controller'
import { get_csrf_token } from '../../app/csrf_token.js'

export default class extends ApplicationController {

	static targets = [
		'spaInput',
	]

	connect() {
	}

	removeItem() {
		if (this.spaInputTargets.some(spaInput => spaInput.name == 'session[session_participant_activities_attributes][][id]' && spaInput.value != '')) {
			const markToDestroyElement = this.createMarkToDestroyElement(this.element)
			this.element.parentNode.append(markToDestroyElement)
		}
		this.element.remove()
	}

	// Creating a new element without any stimulus hooks effectively removes it from the workflow (unless someone starts querySelector'ing around)
	createMarkToDestroyElement(spiElement) {
		const markToDestroyElement = document.createElement('li')
		markToDestroyElement.classList.add('d-none')
		markToDestroyElement.classList.add('mark-for-destroy')

		this.spaInputTargets.forEach(spaInput => {
			if (spaInput.name == 'session[session_participant_activities_attributes][][_destroy]') { spaInput.value = '1' }
			markToDestroyElement.append(spaInput)
		})

		return markToDestroyElement
	}

	editItem() {
		const formData = new FormData()
		formData.append('authenticity_token', get_csrf_token())
		formData.append('participant_id', this.element.dataset.participantId)


		for (const spaInput of this.spaInputTargets) {
			if (spaInput.name == 'session[session_participant_activities_attributes][][_destroy]') { continue }
			formData.append(spaInput.name, spaInput.value)
		}

		fetch('/session_participants/edit_spas', {
			method: 'POST',
			body: formData
		})
		.then(r => r.text())
		.then(html => Turbo.renderStreamMessage(html))
	}
}
